/**
 * Component: sa-why-resources
 * Horizontal carousel with prev/next arrows + progress bar (PC & mobile).
 */
if (!customElements.get('sa-why-resources')) {

  class SaWhyResources extends HTMLElement {
    constructor() {
      super();
      this.handlePrev = this.handlePrev.bind(this);
      this.handleNext = this.handleNext.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
      this._onResize = this._onResize.bind(this);
    }

    connectedCallback() {
      this.carousel = this.querySelector('.sa-why-resources__carousel');
      this.track = this.querySelector('.sa-why-resources__track');
      this.prevBtn = this.querySelector('.sa-why-resources__btn--prev');
      this.nextBtn = this.querySelector('.sa-why-resources__btn--next');
      this.progressBar = this.querySelector('.sa-why-resources__progress-bar');

      if (!this.track) return;

      if (this.prevBtn) this.prevBtn.addEventListener('click', this.handlePrev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.handleNext);
      this.track.addEventListener('scroll', this.handleScroll, { passive: true });

      requestAnimationFrame(() => this.updateProgress());

      if (typeof ResizeObserver !== 'undefined') {
        this._ro = new ResizeObserver(this._onResize);
        this._ro.observe(this.track);
      }
    }

    disconnectedCallback() {
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this.handlePrev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this.handleNext);
      if (this.track) this.track.removeEventListener('scroll', this.handleScroll);
      if (this._ro) {
        this._ro.disconnect();
        this._ro = null;
      }
    }

    _onResize() {
      this.updateProgress();
    }

    getCardWidth() {
      const card = this.track.querySelector('.sa-why-resources__card');
      if (!card) return 300;
      const style = getComputedStyle(this.track);
      const gap = parseFloat(style.gap) || 16;
      return card.offsetWidth + gap;
    }

    handlePrev() {
      if (!this.track) return;
      this.track.scrollBy({ left: -this.getCardWidth(), behavior: 'smooth' });
    }

    handleNext() {
      if (!this.track) return;
      this.track.scrollBy({ left: this.getCardWidth(), behavior: 'smooth' });
    }

    handleScroll() {
      this.updateProgress();
    }

    updateProgress() {
      if (!this.track || !this.progressBar) return;
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const maxScroll = scrollWidth - clientWidth;

      const target = this.carousel || this;

      if (maxScroll <= 0) {
        target.setAttribute('data-has-overflow', 'false');
        this.progressBar.style.width = '100%';
        if (this.prevBtn) this.prevBtn.disabled = true;
        if (this.nextBtn) this.nextBtn.disabled = true;
        return;
      }

      target.setAttribute('data-has-overflow', 'true');
      const pct = (scrollLeft / maxScroll) * 100;
      this.progressBar.style.width = Math.min(100, Math.max(0, pct)) + '%';
      if (this.prevBtn) this.prevBtn.disabled = scrollLeft <= 1;
      if (this.nextBtn) this.nextBtn.disabled = scrollLeft >= maxScroll - 1;
    }
  }

  customElements.define('sa-why-resources', SaWhyResources);
}
